module.exports = __webpack_public_path__ + "img/pr-1.bd0b51a7.png";